import React, { useEffect, useState } from 'react'
import { Tree } from 'primereact/tree'
import './Tree.scss'
import LuxButton from '../buttons/Button'

const LuxTree = (props: {
    items: any[]
    itemsKeys: any
    setItemsKeys: (newItemsKeys: any) => void
    onSplit?: (parentId: string, itemsToSplit: any) => void
    labels?: {
        split?: string
    }
}) => {
    const { items, itemsKeys, setItemsKeys, onSplit, labels } = props

    const customTemplate = (node: any, options: any) => {
        return (
            <div className="p-treenode-header">
                <span className="p-treenode-label">{node.label}</span>
                {onSplit && node?.combined && (
                    <LuxButton
                        color={'005192'}
                        variant={['text']}
                        text={labels?.split ? labels.split : 'Split'}
                        onClick={() => onSplit(node.id, node.combined)}
                    />
                )}
            </div>
        )
    }

    return (
        <div className="luxTree">
            <Tree
                value={items}
                selectionMode={'checkbox'}
                selectionKeys={itemsKeys}
                onSelectionChange={(e: any) => {
                    setItemsKeys(e?.value ? e.value : {})
                }}
                nodeTemplate={customTemplate}
            />
        </div>
    )
}

export default LuxTree
